import { type LBNodeData } from '@/proto/logiblocks/logiblocks';
import { TRIGGER_ICON_COLOR } from '../../styles';
import {
  type GraphData,
  type LBNodeInfo,
  NodeCategory,
  OutputType,
} from '../../types';
import { RefreshClockIcon } from '@/assets/icons/icons';
import { ETAChangeTriggerCustomization } from './ETAChangeTriggerCustomization';
import { buildNodeData } from '../../nodeDataUtils';

export const ETAChangeTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'eta_change_trigger',

  category: NodeCategory.TRIGGER,

  label: 'ETA change',

  hasInput: false,

  getIcon: (size: number) => (
    <RefreshClockIcon color={TRIGGER_ICON_COLOR} width={size} height={size} />
  ),

  outputType: OutputType.SINGLE,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const d = data.eta_change_trigger;
    if (!d) return '';

    if (d?.select_all === true) {
      return 'All';
    }

    const hasFilters =
      (d.courier_ids?.length ?? 0) > 0 ||
      (d.team_ids?.length ?? 0) > 0 ||
      (d.origin_ids?.length ?? 0) > 0 ||
      (d.destination_ids?.length ?? 0) > 0 ||
      (d.product_ids?.length ?? 0) > 0 ||
      d.select_all_origins ||
      d.select_all_teams ||
      d.select_all_destinations ||
      d.select_all_products ||
      d.select_all_transport_providers;

    return hasFilters ? 'Filtered' : '';
  },

  CustomizationComponent: ETAChangeTriggerCustomization,

  createDefaultNodeData: () =>
    buildNodeData('eta_change_trigger', {
      select_all: false,
      courier_ids: [],
      change_by: '',
      direction: '',
      team_ids: [],
      origin_ids: [],
      destination_ids: [],
      product_ids: [],
      select_all_teams: false,
      select_all_origins: false,
      select_all_products: false,
      select_all_transport_providers: false,
      select_all_destinations: false,
    }),
};
